import React from "react";

import "./MagicPending.scss";
import { Block } from "@randajan/jet-react/dom/block";
import { Locale } from "../../../../assets/Locale";

export const MagicPending = (props)=>{
    const { userId } = props;
    const say = Locale.use();
    const email = userId || say("oauthMagicPendingEmailFallback");

    return (
        <Block level={0} className="MagicPending" caption={say("oauthMagicPendingCaption")}>
            <p className="desc">{say("oauthMagicPendingDesc")}</p>
            <p className="email">{email}</p>
            <p className="hint">{say("oauthMagicPendingHint")}</p>
        </Block>
    );
};
